import clusters from './marketing-hreflang-clusters.json';
import { MARKETING_LOCALES, type MarketingLocale } from './localeRoutes';

export type MarketingHreflangClusterKey = keyof typeof clusters;

export const MARKETING_HREFLANG_CLUSTER_KEYS = Object.keys(clusters) as MarketingHreflangClusterKey[];

/** Chemins alternatifs hreflang (clé = code hreflang ISO / régional). */
export type HreflangAlternatePaths = Record<string, string>;

export function marketingHreflangCluster(key: MarketingHreflangClusterKey): HreflangAlternatePaths {
  return { ...clusters[key] };
}

export function normalizeHreflangPath(pathname: string): string {
  return String(pathname || '').replace(/\/+$/, '') || '/';
}

export function findHreflangClusterByPath(pathname: string): HreflangAlternatePaths | undefined {
  const norm = normalizeHreflangPath(pathname);
  for (const cluster of Object.values(clusters)) {
    if (Object.values(cluster).some((p) => normalizeHreflangPath(p) === norm)) {
      return { ...cluster };
    }
  }
  return undefined;
}

const REGIONAL_HREFLANG = new Set(['fr-BE', 'nl-BE', 'nl-NL']);

/** Filtre les entrées langue (en/es/de/it) selon les flags ; garde toujours fr + variantes BE/NL. */
export function filterHreflangAlternatesForActiveLocales(
  alternates: HreflangAlternatePaths,
  activeLocales: MarketingLocale[]
): HreflangAlternatePaths {
  const out: HreflangAlternatePaths = {};
  for (const [code, altPath] of Object.entries(alternates)) {
    if (!altPath) continue;
    if (code === 'fr' || REGIONAL_HREFLANG.has(code)) {
      out[code] = altPath;
      continue;
    }
    if ((MARKETING_LOCALES as readonly string[]).includes(code) && activeLocales.includes(code as MarketingLocale)) {
      out[code] = altPath;
    }
  }
  return out;
}
